import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ViewPatientProfile from "./ViewPatientProfile";
import { getSearchedPatientList } from "../patientSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

interface ViewPatientProfileAccordionProps {
  data: any;
  handleViewProfileClick: (data: any) => void;
  handleVisitButtonClick: (data: any) => void;
}

export default function ViewPatientProfileAccordion({
  data,
  handleViewProfileClick,
  handleVisitButtonClick,
}: ViewPatientProfileAccordionProps) {
  const { firstName, lastName, bsaId } = data;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    // <div>
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel1-content-${bsaId}`}
        id={`panel1-${bsaId}`}
      >
        {firstName} {lastName}
      </AccordionSummary>
      <AccordionDetails>
        <ViewPatientProfile
          key={data?.id}
          patientProfileData={data}
          getProfileButtonClickEvent={(data) => {
            handleViewProfileClick(data);
            dispatch(getSearchedPatientList(null));
          }}
          getCreateVisitButtonClickEvent={
            (data) => {
              handleVisitButtonClick(data);
            }
            // setOpenCreateVisitDialog(true)
          }
        />
      </AccordionDetails>
    </Accordion>
    // </div>
  );
}
